import { GRID_STRING_COL_DEF } from '@mui/x-data-grid-pro';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { renderFormulaRowNumberCell } from '../../../components/GridFormulaRowNumberCell';
import { GRID_FORMULA_ROW_NUMBER_FIELD } from './gridFormulaPositionContext';

/**
 * Autogenerated leftmost column that numbers rows by their view position when
 * `formulaA1Notation` is on. A utility column: not sortable/filterable/editable,
 * excluded from export/print and the column menu, hidden from the columns panel,
 * and excluded from the formula position context (takes no column letter).
 * The header is an empty corner, like a spreadsheet.
 */
export const GRID_FORMULA_ROW_NUMBER_COL_DEF: GridColDef = {
  ...GRID_STRING_COL_DEF,
  type: 'custom',
  field: GRID_FORMULA_ROW_NUMBER_FIELD,
  headerName: '',
  width: 40,
  minWidth: 40,
  align: 'center',
  headerAlign: 'center',
  editable: false,
  sortable: false,
  filterable: false,
  hideable: false,
  resizable: false,
  disableColumnMenu: true,
  disableExport: true,
  disableReorder: true,
  aggregable: false,
  groupable: false,
  chartable: false,
  renderHeader: () => null,
  renderCell: renderFormulaRowNumberCell,
};
